import { Observable } from 'knockout';
import WCCEntity from './entity';

export interface JSONTranscriptJob {
    duration: number
    created_at: string
}

export default class TranscriptJob extends WCCEntity<JSONTranscriptJob> {
    duration: Observable<number>
    createDate: Observable<Date>

    constructor(data: JSONTranscriptJob) {
        super();

        this.duration = this.createField(data, 'duration');
        this.createDate = this.createMappedField(data, 'created_at', WCCEntity.dateMapperNotNull);
    }
}